var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSmrtAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #FFFFFF;\n        stroke-width: 1.92px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_smrt_analysis"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.6,
    cy: 39.51,
    r: 6.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.43,
    y1: 44.34,
    x2: 52.39,
    y2: 51.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53,13.44c-7.02,0-7.35,7.67-14.37,7.67s-6.39-7.67-13.42-7.67-7.34,7.67-14.37,7.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.29,
    y1: 31.65,
    x2: 46.29,
    y2: 23.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.54,
    y1: 30.69,
    x2: 40.54,
    y2: 27.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.34,
    y1: 43.04,
    x2: 38.34,
    y2: 35.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.91,
    y1: 43.04,
    x2: 42.91,
    y2: 35.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.79,
    y1: 32.26,
    x2: 34.79,
    y2: 26.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.04,
    y1: 41.23,
    x2: 29.04,
    y2: 22.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.29,
    y1: 41.23,
    x2: 23.29,
    y2: 20.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.54,
    y1: 41.23,
    x2: 17.54,
    y2: 24.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.79,
    y1: 41.23,
    x2: 11.79,
    y2: 27.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.04,
    y1: 20.15,
    x2: 52.04,
    y2: 41.23
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSmrtAnalysis);
export default __webpack_public_path__ + "static/media/icn_smrt_analysis.0f9df23fe37020efd220ea6efce41439.svg";
export { ForwardRef as ReactComponent };